import type { Execution } from '../types/attacks';

export function executionMetricsRange(detail: Pick<Execution, 'started_at' | 'completed_at'>): { startSec: number; endSec: number } | null {
  if (!detail.started_at) return null;
  const startMs = new Date(detail.started_at).getTime();
  if (Number.isNaN(startMs)) return null;

  const startSec = Math.floor(startMs / 1000);
  let endSec: number;

  if (detail.completed_at) {
    const endMs = new Date(detail.completed_at).getTime();
    endSec = Number.isNaN(endMs) ? Math.floor(Date.now() / 1000) : Math.floor(endMs / 1000);
  } else {
    endSec = Math.floor(Date.now() / 1000);
  }

  if (endSec <= startSec) endSec = startSec + 60;
  endSec += 60;
  return { startSec, endSec };
}
